import { api } from '../../../api';

export type CouponStatus = 'active' | 'expired';

export interface Coupon {
  id: string;
  name: string;
  code: string;
  amountOffTablePercentage: number;
  expirationDate: string;
  description: string | null;
  status: CouponStatus;
}

export interface CouponPayload {
  name: string;
  code: string;
  amountOffTablePercentage: number;
  expirationDate: string;
  description: string | null;
}

export const getCoupons = (restaurantId: string): Promise<Coupon[]> =>
  api.get(`/restaurants/${restaurantId}/coupons`);

export const createCoupon = (
  restaurantId: string,
  payload: CouponPayload,
): Promise<Coupon> => api.post(`/restaurants/${restaurantId}/coupons`, payload);

export const updateCoupon = (
  restaurantId: string,
  couponId: string,
  payload: Required<CouponPayload>,
): Promise<Coupon> =>
  api.put(`/restaurants/${restaurantId}/coupons/${couponId}`, payload);

export const deleteCoupon = (
  restaurantId: string,
  couponId: string,
): Promise<void> =>
  api.delete(`/restaurants/${restaurantId}/coupons/${couponId}`);

export interface VipTier {
  id: string;
  index: number;
  name: string;
  reservationCountThreshold: number | null;
  reservationCountTimeWindowDays: number | null;
  spendAmountThreshold: number | null;
  spendAmountTimeWindowDays: number | null;
  description: string | null;
  amountOffTablePercentage: number;
}

export interface VipTierPayload {
  name: string;
  reservationCountThreshold: number | null;
  reservationCountTimeWindowDays: number | null;
  spendAmountThreshold: number | null;
  spendAmountTimeWindowDays: number | null;
  description: string | null;
  amountOffTablePercentage: number;
}

export const getVipTiers = (restaurantId: string): Promise<VipTier[]> =>
  api.get(`/restaurants/${restaurantId}/vip-tiers`);

export const createVipTier = (
  restaurantId: string,
  payload: VipTierPayload,
): Promise<VipTier> =>
  api.post(`/restaurants/${restaurantId}/vip-tiers`, payload);

export const updateVipTier = (
  restaurantId: string,
  vipTierId: string,
  payload: Required<VipTierPayload>,
): Promise<VipTier> =>
  api.put(`/restaurants/${restaurantId}/vip-tiers/${vipTierId}`, payload);

export const reorderVipTiers = (
  restaurantId: string,
  vipTierIds: string[],
): Promise<void> =>
  api.put(`/restaurants/${restaurantId}/vip-tiers/reorder`, { vipTierIds });

export const deleteVipTier = (
  restaurantId: string,
  vipTierId: string,
): Promise<void> =>
  api.delete(`/restaurants/${restaurantId}/vip-tiers/${vipTierId}`);
